module.exports = __webpack_public_path__ + "static/c8-23604c0fd76f1e4f47633af397379363.jpg";